import { faker } from '@faker-js/faker';
import {
  AddressWithOptionalCoordinates,
  Address,
  CountryCodes,
} from '../types';
import { fakeCoordinatesFactory } from './coordinates';

export const getRandomCountryCode = () =>
  CountryCodes[
    faker.helpers.arrayElement(
      Object.keys(CountryCodes),
    ) as keyof typeof CountryCodes
  ];

export const fakeAddressFactory = {
  createAddressWithoutCoordinates: (
    address: Partial<Omit<Address, 'coordinates'>> = {},
  ) => ({
    street: faker.address.streetAddress(),
    zipCode: faker.address.zipCode('#####'),
    city: faker.address.city(),
    country: CountryCodes['DE'], // random country code wouldn't work with zip code validation
    ...address,
  }),

  createAddress: (address: Partial<Address> = {}): Address => ({
    ...fakeAddressFactory.createAddressWithoutCoordinates(address),
    coordinates: fakeCoordinatesFactory.createCoordinates(),
  }),

  createRealAddressWithoutCoordinates: (
    index?: number,
  ): Omit<Address, 'coordinates'> => {
    const realAddressesWithoutCoordinates = [
      {
        street: 'Höftkamp 2',
        zipCode: '25548',
        city: 'Mühlenbarbek',
        country: CountryCodes.DE,
      },
      {
        street: 'Dr. Hermann-Lindrath-Str. 21',
        zipCode: '23812',
        city: 'Wahlstedt',
        country: CountryCodes.DE,
      },
      {
        street: 'Mühlendamm 1-5',
        zipCode: '24113',
        city: 'Kiel',
        country: CountryCodes.DE,
      },
    ];
    if (index === undefined) {
      return faker.helpers.shuffle(realAddressesWithoutCoordinates)[0];
    }
    return realAddressesWithoutCoordinates[index];
  },

  createRealAddress: (index?: number): Address => {
    const realAddresses = [
      {
        ...fakeAddressFactory.createRealAddressWithoutCoordinates(0),
        coordinates: { latitude: 53.95558, longitude: 9.66234 },
      },
      {
        ...fakeAddressFactory.createRealAddressWithoutCoordinates(1),
        coordinates: { latitude: 53.94802, longitude: 10.19664 },
      },
      {
        ...fakeAddressFactory.createRealAddressWithoutCoordinates(2),
        coordinates: { latitude: 54.3122, longitude: 10.0993 },
      },
    ];
    if (index === undefined) {
      return faker.helpers.shuffle(realAddresses)[0];
    }
    return realAddresses[index];
  },
};

export const fakeAddressWithoutCoordinates: AddressWithOptionalCoordinates =
  fakeAddressFactory.createAddressWithoutCoordinates();
export const fakeAddress: Address = fakeAddressFactory.createAddress();
